module.exports = __webpack_public_path__ + "img/zd-down-1.3a8d3a3e.svg";